import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

interface RawResponse {
	readonly historicDataViewSettings: {
		readonly historicProductDataViewDate: string | null;
	};
}

export interface HistoricDataViewSettings {
	readonly historicProductDataViewDate: Date | null;
}

export interface Result {
	readonly historicDataViewSettings: HistoricDataViewSettings;
}

export const updateHistoricDataViewSettings = async (
	client: ApiClient,
	userId: string,
	id: string,
	date: Date | null
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{id}/historic-data-view-settings');

	try {
		const request = await client.fetch(url.expand({ userId, id }), {
			method: 'PUT',
			body: JSON.stringify({
				historicProductDataViewDate: date !== null ? formatApiDate(date) : null,
			}),
		});
		const response: RawResponse = await request.json();
		return {
			historicDataViewSettings: {
				historicProductDataViewDate:
					response.historicDataViewSettings.historicProductDataViewDate !== null
						? new Date(response.historicDataViewSettings.historicProductDataViewDate)
						: null,
			},
		};
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new UserProductGroupErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
